import { Stack } from 'expo-router';

const ImpactLayout = () => {
  return (
    <Stack>
      <Stack.Screen
        name="period"
        options={{
          headerShown: true,
          headerTitle: '',
          headerBackVisible: false,
          headerShadowVisible: false
        }}
      />
      <Stack.Screen name="map" />
    </Stack>
  );
};

export default ImpactLayout;
